import './_collection-faq.scss';
import component from './collection-faq';

export default component;
